import { render, staticRenderFns } from "./VideoCallRoom.vue?vue&type=template&id=47950236&"
import script from "./VideoCallRoom.vue?vue&type=script&lang=js&"
export * from "./VideoCallRoom.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallRoom.vue?vue&type=style&index=0&id=47950236&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports